import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import { fetchCostAndUsageSumWidgetDataByWidgetIdThunk } from "./fetchCostAndUsageSumWidgetDataByWidgetIdThunk";
import { DashboardWidgetCostAndUsageSummaryRequest } from "../../../../../services/cloudchipr.api";
import { currentDashboardIdSelector } from "../../../selectors/dashboard/currentDashboardIdSelector";
import { RootState } from "../../../../store";
import { buildWidgetThunk } from "../common/buildWidgetThunk";
import { costAndUsageSumWidgetSetupSelector } from "../../../selectors/setups/cost-and-usage/costAndUsageSumWidgetSetupSelector";

export const buildCostAndUsageSumWidgetThunk = createAsyncThunk(
  "dashboards/buildCostAndUsageSumWidget",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;

    const dashboardId = currentDashboardIdSelector(state);
    const setup = costAndUsageSumWidgetSetupSelector(state);

    if (!dashboardId || !setup?.viewId) {
      return;
    }

    const widget: DashboardWidgetCostAndUsageSummaryRequest = {
      name: setup.name,
      date_to: setup.date.to,
      view_id: setup.viewId,
      date_from: setup.date.from,
      date_label: setup.date.label,
      type: "cost_and_usage_summary",
      layout: null,
      filter: setup.filter,
      grouping: setup.grouping,
    };

    try {
      const response = await dispatch(
        buildWidgetThunk({
          widgetId: setup?.id,
          widget,
        }),
      ).unwrap();

      if (response && setup?.id) {
        await dispatch(
          fetchCostAndUsageSumWidgetDataByWidgetIdThunk(response.id),
        );
      }
      return response?.id;
    } catch (e) {
      // @ts-expect-error todo: api fix
      const errMessage = e?.data?.message || "Something went wrong";
      enqueueSnackbar(errMessage, {
        variant: "snackbarAlert",
        AlertSnackBarProps: { severity: "error" },
      });

      return null;
    }
  },
);
